const pendingFiles = new Map<string, Blob>();

export const rememberUploadFile = (objectUrl: string, file: Blob) => {
  pendingFiles.set(objectUrl, file);
};

export const getUploadFile = (objectUrl: string) => pendingFiles.get(objectUrl);

export const releaseUploadFile = (objectUrl: string) => {
  pendingFiles.delete(objectUrl);
};
